import { parseApiError } from '@domain/errors';
import i18n from './index';

export const apiErrorMessage = (err: unknown): string =>
  i18n.t(`errors.${parseApiError(err).code}`);
